import * as React from 'react';
export default function SvgThinkingFace() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    height: "1em",
    id: "a",
    width: "1em",
    x1: "32",
    x2: "32",
    y1: "62",
    y2: "2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#ff9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".192",
    stopColor: "#ffad00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".545",
    stopColor: "#ffd500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".827",
    stopColor: "#ffed00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#fff600"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M32 62c16.569 0 30-13.431 30-30S48.569 2 32 2 2 15.431 2 32s13.431 30 30 30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a1626",
    d: "M36.14 42.29c-2.38-5.87-9.77-8.37-16.45-6.1-2.28.77-1.99 4.7.17 3.88 5.66-2.12 12.63-.13 15.6 2.88.37.36.88-.18.68-.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.2 60.44C7.18 62.52 2.78 54.18 5.73 46.76c1.06-2.65-1.72-6.6 1.19-8.14 3-1.58 5.8.79 5.9 5.96 2.66-.54 6.28-2.58 8.57-2.43 1.25.08 5.63 1.86 7.07 1.96 4.95.33 4.78 6.05-1.59 5.44.1.87-.3 2.43-1.22 3.33.4 1.01.46 2.51-.94 3.86.56 3.51-4.23 5.58-7.51 3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99a8ae",
    d: "M16.98 61.19C6.26 63.48 2.06 54.05 4.88 47.04c1.16-2.9-1.92-7.42 1.2-9.11 3.2-1.74 7.19.14 7.29 5.83 2.85-.6 5.97-2.64 8.42-2.48 1.34.09 6.03 2.15 7.57 2.26 5.29.36 4.88 7.1-1.93 6.43.11.96-.09 2.1-1.08 3.1.43 1.11.49 2.76-1 4.24.57 3.84-4.87 5.95-8.37 3.88zm1.98-2.67-1.19 1.22c4.9 2.19 8.33-2.95 3.15-4.83 1.46.06 2.52.61 3.03 1.01 1.52-2.11 1.35-3.48-1.66-5.31 2.05.42 2.81 1.34 2.81 1.34 1.49-2.66.62-3.78-2.11-5.17 2.03.13 3.3 1.19 4.53 1.48 3.08.72 4.41-3.01 1.84-3.18-3.16-.21-6.19-2.14-8.05-1.99-2.66.21-4.21 1.73-10.02 3.31.27-5.15-1.19-7.78-3.74-7-2.21.67.53 3.74-.84 7.79-3.06 9.06 4.02 15.1 12.25 11.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a1626",
    d: "M22.79 16.45c2.13.57 3.28 3.2 2.57 5.87s-3.02 4.37-5.16 3.79c-2.14-.57-3.28-3.2-2.57-5.86.72-2.67 3.03-4.37 5.16-3.8zm18.88 3.19c2.13.57 3.28 3.2 2.57 5.87s-3.02 4.37-5.16 3.79c-2.14-.57-3.28-3.2-2.57-5.86.72-2.67 3.02-4.37 5.16-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d69600",
    d: "M42.75 12.92c-7.48-.29-8.62 5.76-3.17 5.31 9.64-.8 14.54-4.87 3.17-5.31zM21.74 7.16c-11.34.84-6.31 4.74 3.36 5.2 5.45.26 4.1-5.75-3.36-5.2z"
  }));
}